/** Valid Mode Category values. `STORM_MODE` is only one used in business logic (getStormModeLockedRowIndex) */
export const MODE_CATEGORY = {
  NONE: '',
  MANUAL: 'MANUAL',
  AUTO: 'AUTO',
  PANEL_CONTROL: 'PANEL_CONTROL',
  DUAL_TANK: 'DUAL_TANK',
  MASTER_TANK: 'MASTER_TANK',
  CONSTANT_FLOW: 'CONSTANT_FLOW',
  CONSTANT_PRESSURE: 'CONSTANT_PRESSURE',
  CIP: 'CIP',
  CEB: 'CEB',
  STERILIZATION: 'STERILIZATION',
  LEGACY_CONTROL: 'LEGACY_CONTROL',
  STORM_MODE: 'STORM_MODE',
} as const;

export type ModeCategoryValue = (typeof MODE_CATEGORY)[keyof typeof MODE_CATEGORY];
